import styled from 'styled-components/macro';

export const NavBar = styled.div`
  display: flex;
  width: 100%;
  align-items: stretch;
  justify-content: center;
  overflow: hidden;
  background-color: ${({ theme, primaryColor }) => primaryColor || theme.dark4};
  padding: 0px 50px 0 50px;
  height: auto;
  position: sticky;
  top: 0;
  z-index: 10;

  @media (max-width: ${({ theme }) => theme.breakpoints.xl}px) {
    position: relative;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    padding: ${({ withBorder }) =>
      withBorder ? 'padding: 0px 50px 0 50px' : '0px'};
    min-height: 40px;
  }
`;

export const SubRouteNavBar = styled.div`
  position: relative;
  background-color: ${({ theme, background }) => theme[background]};
  display: flex;
  justify-content: center;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    width: 100%;
  }
`;

export const DecorationBar = styled.div`
  position: absolute;
  transition: all 0.3s;
  height: ${({ selectedHeight }) => selectedHeight};
  background-color: ${({ secondaryColor }) => secondaryColor};
  bottom: 0px;
  left: ${({ selectedLeft }) => selectedLeft || 0}px;
  width: ${({ selectedWidth }) => selectedWidth || 0}px;
  z-index: 1;
`;
